import React from "react";
import Layout from "./Layout";
import HomeImage from "./HomeImage";
import { FeaturedCategories } from "./FeaturedCategories";
import { FeaturedProducts } from "./FeaturedProducts";
import WhyChooseUs from "./WhyChooseUs";
import Testimonials from "./Testimonials";

export default function Home() {
  return (
    <Layout>
      <HomeImage />
      <FeaturedCategories />
      <FeaturedProducts />
      <WhyChooseUs />
      <Testimonials />
    </Layout>
  );
}
